import * as React from 'react';

const SvgSupport = (props) => (
  <svg
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    {...props}
  >
    <path
      d='M14.167 2.025H5.833c-2.5 0-4.166 1.667-4.166 4.167v5c0 2.5 1.666 4.166 4.166 4.166v1.775c0 .667.742 1.067 1.292.692l3.708-2.467h3.334c2.5 0 4.166-1.666 4.166-4.166v-5c0-2.5-1.666-4.167-4.166-4.167ZM10 12.167a.624.624 0 1 1-.002-1.249.624.624 0 0 1 .002 1.249Zm1.05-3.459c-.325.217-.425.359-.425.592v.175A.63.63 0 0 1 10 10.1a.63.63 0 0 1-.625-.625V9.3c0-.967.708-1.442.975-1.625.308-.208.408-.35.408-.567A.761.761 0 0 0 10 6.35a.761.761 0 0 0-.758.758.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625 2.01 2.01 0 0 1 4.016 0c0 .95-.7 1.425-.958 1.6Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgSupport;
